import apiBase from "../../api/axios";

// ── Grupos ────────────────────────────────────────────────────────────────────

export const getGruposService = async () => {
  const res = await apiBase.get("v1/roles-permisos/grupos/");
  return res.data;
};

export const getGrupoDetailService = async (id) => {
  const res = await apiBase.get(`v1/roles-permisos/grupos/${id}/`);
  return res.data;
};

export const syncGrupoPermisosService = async (id, permissionIds) => {
  const res = await apiBase.post(`v1/roles-permisos/grupos/${id}/sync-permisos/`, {
    permission_ids: permissionIds,
  });
  return res.data;
};

// ── Permisos disponibles ───────────────────────────────────────────────────────

export const getPermisosDisponiblesService = async () => {
  const res = await apiBase.get("v1/roles-permisos/permisos/");
  return res.data;
};

// ── Usuarios ──────────────────────────────────────────────────────────────────

export const getUsuariosPermisosService = async (search = "") => {
  let url = "v1/roles-permisos/usuarios/";
  if (search) url += `?search=${encodeURIComponent(search)}`;
  const res = await apiBase.get(url);
  return res.data;
};

export const getUsuarioPermisoDetailService = async (id) => {
  const res = await apiBase.get(`v1/roles-permisos/usuarios/${id}/`);
  return res.data;
};

export const syncUsuarioGruposService = async (id, grupoIds) => {
  const res = await apiBase.post(`v1/roles-permisos/usuarios/${id}/sync-grupos/`, {
    grupo_ids: grupoIds,
  });
  return res.data;
};

export const syncUsuarioPermisosEspecialesService = async (id, permisoIds) => {
  const res = await apiBase.post(
    `v1/roles-permisos/usuarios/${id}/sync-permisos-especiales/`,
    { permiso_ids: permisoIds }
  );
  return res.data;
};
